/* This file is autogenerated, see readme.md for instructions */
import ImagesSvgIcon from '@bloomreach/banana-theme/icons/images.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ImagesIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ImagesSvgIcon />
    </Icon>
  );
});

ImagesIcon.displayName = 'ImagesIcon';

export default ImagesIcon;
